module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am grateful to Graham Greene who, in 1989, at the Oxford & Cambridge Club, told us the anecdote on which I based the Rain Queen story;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And to Harould Courlander’s collection of oral African tales, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Crest and the Hide")]), _vm._v(", for reminding me of a story from my childhood;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And to Rosemary Clunie.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6078de5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002_Ack.vue
// module id = 69
// module chunks = 0